import { OverlayToaster, Position } from '@blueprintjs/core'

const PrinterToaster = OverlayToaster.create({
  className: 'printer-toaster',
  position: Position.TOP,
  maxToasts: 5
})

export default PrinterToaster
